import { navigateTo } from '#imports'
import { useBuyerScorecardFilterConditionStore } from '@/stores/buyerScorecardFilterConditionStore'

/**
 * アプリケーションの状態をリセットする
 */
const _clearState = () => {
  // スコアカード検索条件のステートをクリア
  const store = useBuyerScorecardFilterConditionStore()
  store.$reset()
}

export const forceLogout = () => {
  _clearState()
  window.location.href = '/mypage/login'
}

export const forceLogoutToResetPassword = () => {
  _clearState()
  navigateTo('/mypage/resetpasswordconfirm')
}

export const forceAdminLogout = () => {
  navigateTo('/mypage/admin/login')
}
